const breakpoints = {
  sm: 420,
  md: 768,
  lg: 1024,
  xl: 1280,
};

export const mediaQueries = {
  sm: `@media (min-width: ${breakpoints.sm / 16}rem)`,
  md: `@media (min-width: ${breakpoints.md / 16}rem)`,
  lg: `@media (min-width: ${breakpoints.lg / 16}rem)`,
  xl: `@media (min-width: ${breakpoints.xl / 16}rem)`,
};

// `not all and` is the Media Queries Level 3 negation, so each `until` query
// matches exactly when its `from` query does not: no overlap at the breakpoint
// and no gap below it. Range syntax (`width < 48rem`) needs Safari 16.4 and
// the browserslist still resolves iOS 11 and 15.
export const mediaQueriesUntil = {
  sm: `@media not all and (min-width: ${breakpoints.sm / 16}rem)`,
  md: `@media not all and (min-width: ${breakpoints.md / 16}rem)`,
  lg: `@media not all and (min-width: ${breakpoints.lg / 16}rem)`,
  xl: `@media not all and (min-width: ${breakpoints.xl / 16}rem)`,
};
